function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.069 155.4v34.1H194.63v-73.988l-72.433-49.197-70.28 47.979c5.5 7.72 7.877 15.238 7.061 22.527-.827 7.394-3.804 13.607-8.91 18.58z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.83 114.921l-85.477-60.092-77.793 53.912a47.435 47.435 0 012.977 2.052c1.083.82 2.458 2.091 4.143 3.824l70.302-48.605 78.459 53.256 7.388-4.347zm-91.214 7.621h59.583v40.125h-59.583z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#A1887F",
  d: "M75.145 128.292h26.898v48.75H75.145z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.116 182.854h66.547m-131.165 0h16.95m38.988-55.104H70.751V122h35.685m-34.185 55.167h32.685v5.625H72.251zm0 5.75h32.685v6.583H72.251z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.045 68.342l-3 2.991h2.991l.01-2.991zm13.266 2.991l1.978-3H65.045l-.08 27.792 3.013-4.57.058-20.222h13.275zm-13.266-2.991l-3 2.991h2.991l.01-2.991zm13.266 2.991l1.978-3H65.045l-.08 27.792 3.013-4.57.058-20.222h13.275z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 105.405)",
  stroke: "#371447",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.467,
  cy: 28.386,
  rx: 28.467,
  ry: 28.386
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.467 85.595V25.329m-.437 13.975l-9.636-4.367m18.394-8.734L28.03 33.19"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-135 34.813 72.975)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-122 41.46 69.939)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-135 37.349 74.854)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-145 33.803 76.432)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-156 29.528 78.304)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(174 14.216 81.943)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(167 12.117 82.226)",
  fill: "#371447"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 8,
  r: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M157.552 72.155c.982-2.35 3.334-2.217 4.033-2.217a6.48 6.48 0 012.912.685c.987-6.184 6.427-10.915 12.99-10.915 5.122 0 9.56 2.882 11.731 7.088a10.47 10.47 0 015.7-1.672c5.741 0 10.396 4.58 10.396 10.23-.058 2.653-1.24 4.716-3.547 6.19-7.145-.052-15.873-.111-26.185-.18m60.791 108.071c.124-.71.188-1.44.188-2.185 0-7.07-5.823-12.802-13.006-12.802-2.632 0-5.082.77-7.129 2.093-2.715-5.263-8.267-8.87-14.675-8.87h-.043",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.13 189.563H240",
  stroke: "#371447",
  strokeWidth: 2.891
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 124.352 70.27)",
  cx: 124.352,
  cy: 70.27,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 120.658 74.998)",
  cx: 120.658,
  cy: 74.998,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 130.617 73.842)",
  cx: 130.617,
  cy: 73.842,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 126.923 78.57)",
  cx: 126.923,
  cy: 78.57,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 135.883 77.483)",
  cx: 135.883,
  cy: 77.483,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 132.19 82.211)",
  cx: 132.189,
  cy: 82.211,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 141.15 81.125)",
  cx: 141.15,
  cy: 81.125,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 137.456 85.853)",
  cx: 137.456,
  cy: 85.853,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 146.417 84.766)",
  cx: 146.417,
  cy: 84.766,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 142.723 89.494)",
  cx: 142.723,
  cy: 89.494,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 151.684 88.408)",
  cx: 151.684,
  cy: 88.408,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 147.99 93.136)",
  cx: 147.99,
  cy: 93.136,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 156.95 92.05)",
  cx: 156.951,
  cy: 92.049,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 153.257 96.777)",
  cx: 153.257,
  cy: 96.777,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 162.218 95.69)",
  cx: 162.218,
  cy: 95.691,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 158.524 100.419)",
  cx: 158.524,
  cy: 100.419,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 167.485 99.332)",
  cx: 167.485,
  cy: 99.332,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 163.79 104.06)",
  cx: 163.791,
  cy: 104.06,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 172.751 102.974)",
  cx: 172.751,
  cy: 102.974,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 169.057 107.702)",
  cx: 169.057,
  cy: 107.702,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 178.018 106.615)",
  cx: 178.018,
  cy: 106.615,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 174.324 111.343)",
  cx: 174.324,
  cy: 111.343,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 183.285 110.257)",
  cx: 183.285,
  cy: 110.257,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 179.591 114.985)",
  cx: 179.591,
  cy: 114.985,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 188.552 113.898)",
  cx: 188.552,
  cy: 113.898,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  transform: "rotate(38 184.858 118.626)",
  cx: 184.858,
  cy: 118.626,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M144 130.5l-14.5 13m30.5-14l-14.5 13m15.5 0l-14.5 13",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "square"
}));

function SvgHomeXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHomeXl;